import { Box, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import type { Route } from 'nextjs-routes';
import PageNextJs from 'nextjs/PageNextJs';

import SeoPageHeading from './SeoPageHeading';

type Props<Pathname extends Route['pathname']> = {
  pathname: Pathname;
  title: string;
  children: React.ReactNode;
};

// Shared SSR shell for explorer list pages that still load the body with `ssr: false`.
const SeoListPageShell = <Pathname extends Route['pathname']>({ pathname, title, children }: Props<Pathname>) => {
  const pageBg = useColorModeValue('#FBFCFE', '#171717');

  return (
    <PageNextJs pathname={ pathname }>
      <Box px={{ base: 4, lg: 6 }} bg={ pageBg } pb={ 0 }>
        <SeoPageHeading title={ title }/>
      </Box>
      { children }
    </PageNextJs>
  );
};

export default SeoListPageShell;
